import { TableCell, TableRow } from '@mui/material'
import React from 'react'
import SeriesQrGet from './actions/seriesQr/SeriesQrGet'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SeriesChangesGet from './actions/seriesChanges/SeriesChangesGet';
import SeriesOneFormAdd from './form/seriesOne/SeriesOneFormAdd';

const BoxOneSeriesItem = ({ series }) => {
  return (
    <TableRow>
        <TableCell align='center'>
            {series.id}
        </TableCell>
        <TableCell align='center'>
            {series.seriesText}
            {series.anotherSeries}
        </TableCell>
        <TableCell align='center'>
            {series.type ? series.type.name : ''}
        </TableCell>
        <TableCell align='center'>
            {series.good ? series.good.name : ''}
        </TableCell>
        <TableCell align='center'>
            {/* {series.isPacked ? 'так' : ''} */}
            {
                series.isPacked && series.isPackedConfirm ? // Якщо упаковано та підтверджено ВТК
                    <CheckCircleOutlineIcon 
                        sx={{
                            color: '#27AE60'
                        }}
                    />
                : 
                series.isPacked ? // Якщо лише упаковано
                    <CheckCircleOutlineIcon 
                        sx={{
                            color: 'orange'
                        }}
                    />
                : ''
            }
        </TableCell>
        <TableCell align='center' className='myTable__actions'>
            {
                series && !series.seriesText && series.anotherSeries ?
                // series && !series.seriesText  ?
                    <SeriesOneFormAdd
                        series={series}
                    />
                : ''
            }
            <SeriesQrGet
                seriesId={series.id}
            />
            <SeriesChangesGet
                seriesId={series.id}
            />
        </TableCell>
    </TableRow>
  )
}

export default BoxOneSeriesItem